// extracted by mini-css-extract-plugin
export var back = "float-module--back--DE+LX";
export var container = "float-module--container--Q9bSA";
export var move1 = "float-module--move1--f6u3B";
export var move2 = "float-module--move2--3zaXO";
export var moving1 = "float-module--moving1--VrXCv";
export var moving2 = "float-module--moving2--MaK73";